(function () {
  'use strict';

  var formInterceptors = {};

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function collectProperties(formData) {
    var properties = {};

    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.*)\]$/);
      if (!match) return;
      properties[match[1]] = value;
    });

    return Object.keys(properties).length ? properties : null;
  }

  function getSubmitButtons(form) {
    return Array.from(document.querySelectorAll('[type="submit"][form="' + form.getAttribute('id') + '"]'));
  }

  function toggleSubmitButtons(form, disabled) {
    getSubmitButtons(form).forEach(function (button) {
      if (disabled) {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('aria-busy', 'true');
      } else {
        button.removeAttribute('aria-busy');
        button.removeAttribute('aria-disabled');
      }
    });
  }

  function handleError(form, message) {
    var errorEl = form.querySelector('.product-form__error-message');
    if (!errorEl) return;

    errorEl.toggleAttribute('hidden', !message);
    errorEl.textContent = message || '';
  }

  function buildPriceMarkup(variant) {
    var compareMarkup = '';

    if (variant.compareAtPrice && variant.compareAtPrice !== '' && variant.compareAtPrice !== variant.price) {
      compareMarkup = '<span class="desk-accessory-card__price-compare">' + escapeHtml(variant.compareAtPrice) + '</span>';
    }

    return compareMarkup + '<span class="desk-accessory-card__price-current">' + escapeHtml(variant.price) + '</span>';
  }

  function findVariantById(variants, variantId) {
    return (variants || []).find(function (variant) {
      return String(variant.id) === String(variantId);
    }) || null;
  }

  function findSwatchByValue(swatches, optionValue) {
    return (swatches || []).find(function (swatch) {
      return String(swatch.optionValue) === String(optionValue);
    }) || null;
  }

  function findFirstAvailableVariant(variants) {
    return (variants || []).find(function (variant) {
      return !!variant.available;
    }) || null;
  }

  function findVariantByOptions(variants, selectedOptions) {
    return (variants || []).find(function (variant) {
      return (variant.options || []).every(function (opt, i) {
        return selectedOptions[i] == null || String(opt) === String(selectedOptions[i]);
      });
    }) || null;
  }

  function resolveSelectedVariant(accessory) {
    var selectedOptions = accessory.selectedOptions || [];
    var selectedVariant;

    if (selectedOptions.length > 0) {
      selectedVariant = findVariantByOptions(accessory.variants, selectedOptions);
      if (selectedVariant) {
        accessory.selectedVariantId = selectedVariant.id;
        accessory.selectedOptions = (selectedVariant.options || []).slice();
        return selectedVariant;
      }
    }

    selectedVariant = findVariantById(accessory.variants, accessory.selectedVariantId);
    if (selectedVariant) {
      accessory.selectedOptions = (selectedVariant.options || []).slice();
      return selectedVariant;
    }

    selectedVariant = findFirstAvailableVariant(accessory.variants);
    if (selectedVariant) {
      accessory.selectedVariantId = selectedVariant.id;
      accessory.selectedOptions = (selectedVariant.options || []).slice();
      return selectedVariant;
    }

    selectedVariant = accessory.variants[0] || null;
    if (selectedVariant) {
      accessory.selectedVariantId = selectedVariant.id;
      accessory.selectedOptions = (selectedVariant.options || []).slice();
    }
    return selectedVariant;
  }

  function buildCardMarkup(instance, accessory, index) {
    var checkboxId = instance.blockKey + '-toggle-' + index;
    var selectedVariant = resolveSelectedVariant(accessory);
    var selectedOptions = accessory.selectedOptions || [];
    var hasOptions = accessory.options && accessory.options.length > 0;
    var imageMarkup = selectedVariant && selectedVariant.image
      ? '<a class="desk-accessory-card__media" href="' + escapeHtml(selectedVariant.imageLarge || selectedVariant.image) + '" target="_blank" rel="noopener" aria-label="' + escapeHtml(accessory.productTitle) + '">' +
          '<img class="desk-accessory-card__image" loading="lazy" src="' + escapeHtml(selectedVariant.image) + '" alt="' + escapeHtml(accessory.productTitle) + '">' +
        '</a>'
      : '<div class="desk-accessory-card__image desk-accessory-card__image--placeholder" aria-hidden="true"></div>';
    var variantTitle = selectedOptions.filter(function (o) { return o && o !== 'Default Title'; }).join(' / ');
    var variantTitleMarkup = hasOptions && variantTitle
      ? '<p class="desk-accessory-card__variant-title">' + escapeHtml(variantTitle) + '</p>'
      : '<p class="desk-accessory-card__variant-title" hidden></p>';
    var swatchMarkup = '';

    if (hasOptions) {
      swatchMarkup = accessory.options.map(function (optionGroup) {
        var optPos = optionGroup.position;
        var selectedVal = selectedOptions[optPos] != null ? String(selectedOptions[optPos]) : '';
        var groupName = instance.blockKey + '-opt-' + index + '-' + optPos;
        return '<ul class="desk-accessory-card__swatches swatches swatches--' + escapeHtml(instance.swatchRounded) + '" data-desk-accessory-swatches data-option-index="' + optPos + '">' +
          optionGroup.swatches.map(function (swatch, si) {
            var swatchId = instance.blockKey + '-sw-' + index + '-' + optPos + '-' + si;
            var swatchStyle = '--swatch-background: ' + escapeHtml(swatch.swatchBackground || '#cccccc') + ';';
            if (swatch.swatchImage) {
              swatchStyle += ' background-image: url(' + escapeHtml(swatch.swatchImage) + ');';
            }
            return '<li class="desk-accessory-card__swatch-item">' +
              '<magnet-element class="block">' +
                '<input id="' + swatchId + '" class="sr-only" type="radio"' +
                  ' name="' + escapeHtml(groupName) + '"' +
                  ' value="' + escapeHtml(swatch.optionValue) + '"' +
                  (swatch.optionValue === selectedVal ? ' checked' : '') + '>' +
                '<label class="color-swatch' + (swatch.swatchImage ? ' with-image' : '') + ' block relative" for="' + swatchId + '"' +
                  ' title="' + escapeHtml(swatch.optionValue) + '"' +
                  ' style="' + swatchStyle + '">' +
                  '<span class="tooltip opacity-0 pointer-events-none text-xs rounded-full z-10">' + escapeHtml(swatch.optionValue) + '</span>' +
                '</label>' +
              '</magnet-element>' +
              '</li>';
          }).join('') +
          '</ul>';
      }).join('');
    }

    return '' +
      '<article class="desk-accessory-card" data-desk-accessory-card data-accessory-index="' + index + '" data-selected-variant-id="' + escapeHtml(accessory.selectedVariantId) + '" data-product-id="' + escapeHtml(accessory.productId) + '">' +
        (selectedVariant && selectedVariant.image ? imageMarkup : '<div class="desk-accessory-card__media">' + imageMarkup + '</div>') +
        '<div class="desk-accessory-card__content">' +
          '<div class="desk-accessory-card__copy">' +
            '<a class="desk-accessory-card__product-title" href="' + escapeHtml(accessory.productUrl || '#') + '">' + escapeHtml(accessory.productTitle) + '</a>' +
            variantTitleMarkup +
          '</div>' +
          '<div class="desk-accessory-card__price">' + buildPriceMarkup(selectedVariant) + '</div>' +
          swatchMarkup +
          '<label class="desk-accessory-card__toggle desk-accessory-card__toggle--' + escapeHtml(instance.buttonStyle) + ' desk-accessory-card__toggle--' + escapeHtml(instance.buttonSize) + '" for="' + checkboxId + '">' +
            '<input id="' + checkboxId + '" class="desk-accessory-card__checkbox" type="checkbox" value="' + escapeHtml(accessory.selectedVariantId) + '"' + (accessory.productAvailable === false ? ' disabled' : '') + '>' +
            '<span class="desk-accessory-card__toggle-state desk-accessory-card__toggle-state--add">' +
              '<svg class="desk-accessory-card__toggle-icon desk-accessory-card__toggle-icon--plus" viewBox="0 0 368 368" fill="none" aria-hidden="true" focusable="false">' +
                '<rect x="0" y="160" width="368" height="48" rx="24" fill="currentColor" />' +
                '<rect x="160" y="0" width="48" height="368" rx="24" fill="currentColor" />' +
              '</svg>' +
              '<span class="desk-accessory-card__toggle-text desk-accessory-card__toggle-text--add">' + escapeHtml(instance.checkboxLabel) + '</span>' +
            '</span>' +
            '<span class="desk-accessory-card__toggle-state desk-accessory-card__toggle-state--added">' +
              '<svg class="desk-accessory-card__toggle-icon desk-accessory-card__toggle-icon--check" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
                '<path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />' +
              '</svg>' +
              '<span class="desk-accessory-card__toggle-text desk-accessory-card__toggle-text--added">' + escapeHtml(instance.addedLabel) + '</span>' +
            '</span>' +
          '</label>' +
          '<p class="desk-accessory-card__status"' + (accessory.productAvailable === false ? '' : ' hidden') + '>' + escapeHtml(instance.soldOutLabel) + '</p>' +
        '</div>' +
      '</article>';
  }

  function updateCardFromVariant(card, variant, accessory) {
    if (!card || !variant) return;

    card.setAttribute('data-selected-variant-id', variant.id);

    var image = card.querySelector('.desk-accessory-card__image');
    if (image && variant.image) {
      image.src = variant.image;
    }

    var mediaLink = card.querySelector('a.desk-accessory-card__media');
    if (mediaLink && variant.image) {
      mediaLink.href = variant.imageLarge || variant.image;
    }

    var variantTitle = card.querySelector('.desk-accessory-card__variant-title');
    if (variantTitle) {
      var title = (variant.options || []).filter(function (o) { return o && o !== 'Default Title'; }).join(' / ');
      variantTitle.textContent = title;
      variantTitle.hidden = !title;
    }

    var price = card.querySelector('.desk-accessory-card__price');
    if (price) {
      price.innerHTML = buildPriceMarkup(variant);
    }

    card.querySelectorAll('[data-desk-accessory-swatches]').forEach(function (group) {
      var optPos = parseInt(group.getAttribute('data-option-index'), 10);
      var selectedVal = variant.options && variant.options[optPos] != null ? String(variant.options[optPos]) : '';
      group.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.checked = input.value === selectedVal;
      });
    });

    var checkbox = card.querySelector('.desk-accessory-card__checkbox');
    if (checkbox) {
      var wasChecked = checkbox.checked;
      checkbox.value = variant.id;
      checkbox.disabled = accessory && accessory.productAvailable === false;
      checkbox.checked = accessory && accessory.productAvailable === false ? false : wasChecked;
    }

    var status = card.querySelector('.desk-accessory-card__status');
    if (status) {
      status.hidden = !(accessory && accessory.productAvailable === false);
    }
  }

  function bindCardEvents(instance) {
    instance.track.querySelectorAll('[data-desk-accessory-card]').forEach(function (card) {
      var index = parseInt(card.getAttribute('data-accessory-index'), 10);
      var accessory = instance.currentAccessories[index];

      if (!accessory) return;

      card.querySelectorAll('[data-desk-accessory-swatches] input[type="radio"]').forEach(function (swatchInput) {
        swatchInput.addEventListener('change', function (event) {
          var optionIndex = parseInt(event.target.closest('[data-desk-accessory-swatches]').getAttribute('data-option-index'), 10);
          var clickedValue = event.target.value;
          var newSelectedOptions = (accessory.selectedOptions || []).slice();
          newSelectedOptions[optionIndex] = clickedValue;

          var selectedVariant = findVariantByOptions(accessory.variants, newSelectedOptions);

          if (!selectedVariant || !selectedVariant.available) {
            var fallback = (accessory.variants || []).find(function (v) {
              return v.available && String((v.options || [])[optionIndex]) === String(clickedValue);
            });
            selectedVariant = fallback || selectedVariant;
          }

          if (!selectedVariant) return;

          accessory.selectedVariantId = selectedVariant.id;
          accessory.selectedOptions = (selectedVariant.options || []).slice();
          updateCardFromVariant(card, selectedVariant, accessory);
        });
      });
    });
  }

  function renderAccessories(instance, sourceVariantId) {
    var accessories = instance.accessoryMap[String(sourceVariantId)] || [];

    instance.currentAccessories = accessories.map(function (accessory) {
      return {
        productId: accessory.productId,
        productTitle: accessory.productTitle,
        productUrl: accessory.productUrl,
        productAvailable: accessory.productAvailable,
        selectedVariantId: accessory.selectedVariantId,
        selectedOptions: (accessory.selectedOptions || []).slice(),
        selectedVariantAvailable: accessory.selectedVariantAvailable,
        variants: accessory.variants.map(function (variant) {
          return {
            id: variant.id,
            options: (variant.options || []).slice(),
            title: variant.title,
            available: variant.available,
            image: variant.image,
            imageLarge: variant.imageLarge,
            price: variant.price,
            compareAtPrice: variant.compareAtPrice
          };
        }),
        options: (accessory.options || []).map(function (optGroup) {
          return {
            name: optGroup.name,
            position: optGroup.position,
            swatches: (optGroup.swatches || []).map(function (swatch) {
              return {
                optionValue: swatch.optionValue,
                available: swatch.available,
                swatchBackground: swatch.swatchBackground,
                swatchImage: swatch.swatchImage
              };
            })
          };
        })
      };
    });

    if (!instance.currentAccessories.length) {
      instance.track.innerHTML = '';
      instance.wrapper.hidden = true;
      return;
    }

    instance.track.innerHTML = instance.currentAccessories.map(function (accessory, index) {
      return buildCardMarkup(instance, accessory, index);
    }).join('');

    instance.wrapper.hidden = false;
    bindCardEvents(instance);
  }

  function getCurrentSourceVariantId(instance) {
    var variantInput = instance.form.querySelector('[name="id"]');
    return variantInput ? variantInput.value : null;
  }

  function ensureFormInterceptor(form) {
    if (formInterceptors[form.getAttribute('id')]) return;
    formInterceptors[form.getAttribute('id')] = true;

    form.addEventListener(
      'submit',
      function (event) {
        if (document.body.classList.contains('template-cart')) return;
        if (typeof theme !== 'undefined' && theme.settings && theme.settings.cartType === 'page') return;

        var accessorySelections = Array.from(
          document.querySelectorAll(
            '.desk-accessories[data-form-id="' + form.getAttribute('id') + '"] .desk-accessory-card__checkbox:checked:not(:disabled)'
          )
        );

        if (accessorySelections.length === 0) return;

        if (typeof theme === 'undefined' || !theme.routes || !theme.utils || !theme.pubsub) {
          console.warn('[desk-accessories] theme object not ready - accessories skipped');
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        handleError(form);

        var formData = new FormData(form);
        var mainVariantId = parseInt(formData.get('id'), 10);
        var quantity = parseInt(formData.get('quantity'), 10) || 1;
        var properties = collectProperties(formData);
        var mainItem = { id: mainVariantId, quantity: quantity };
        var activeElement = event.submitter || getSubmitButtons(form)[0];
        var sectionsToBundle = [];

        if (properties) {
          mainItem.properties = properties;
        }

        // Align with the theme's existing add-on and product-form flows:
        // dispatch the hook, but let the theme decide whether any sections need bundling.
        var items = [mainItem].concat(
          accessorySelections
            .map(function (input) {
              return parseInt(input.value, 10);
            })
            .filter(function (variantId) {
              return !Number.isNaN(variantId);
            })
            .map(function (variantId) {
              return { id: variantId, quantity: 1, properties: { '_upsell_add_ons': 'true' } };
            })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:bundled-sections', {
            bubbles: true,
            detail: { sections: sectionsToBundle }
          })
        );

        toggleSubmitButtons(form, true);

        fetch(
          theme.routes.cart_add_url,
          Object.assign({}, theme.utils.fetchConfig('javascript'), {
            body: JSON.stringify({
              items: items,
              sections: sectionsToBundle,
              sections_url: window.location.pathname
            })
          })
        )
          .then(function (response) {
            return response.json();
          })
          .then(function (parsedState) {
            if (parsedState.status) {
              handleError(form, parsedState.description);
              document.dispatchEvent(
                new CustomEvent('ajaxProduct:error', {
                  detail: { errorMessage: parsedState.description }
                })
              );
              return null;
            }

            return fetch(
              theme.routes.cart_url,
              Object.assign({}, theme.utils.fetchConfig('json', 'GET'))
            )
              .then(function (response) {
                return response.json();
              })
              .then(function (cartJson) {
                cartJson.sections = parsedState.sections;

                theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                  source: 'desk-accessories',
                  productVariantId: mainVariantId,
                  cart: cartJson
                });

                document.dispatchEvent(
                  new CustomEvent('ajaxProduct:added', {
                    detail: { product: parsedState }
                  })
                );

                var quickViewModal = form.closest('quick-view');
                var cartDrawer = document.querySelector('cart-drawer');

                if (quickViewModal && cartDrawer) {
                  document.body.addEventListener(
                    'modal:afterHide',
                    function () {
                      setTimeout(function () {
                        cartDrawer.show(activeElement);
                      });
                    },
                    { once: true }
                  );
                  quickViewModal.hide(true);
                  return;
                }

                if (cartDrawer) {
                  cartDrawer.show(activeElement);
                }

                return null;
              });
          })
          .catch(function (error) {
            console.error('[desk-accessories] Error adding items to cart:', error);
          })
          .finally(function () {
            toggleSubmitButtons(form, false);
          });
      },
      { capture: true }
    );
  }

  function initDeskAccessories(wrapper) {
    if (wrapper.dataset.deskAccessoriesInitialized === 'true') return;

    var formId = wrapper.getAttribute('data-form-id');
    var form = document.getElementById(formId);
    var dataNode = wrapper.querySelector('[data-desk-accessories-map]');

    if (!form || !dataNode) return;

    wrapper.dataset.deskAccessoriesInitialized = 'true';

    var instance = {
      wrapper: wrapper,
      form: form,
      track: wrapper.querySelector('[data-desk-accessories-cards]'),
      accessoryMap: JSON.parse(dataNode.textContent || '{}'),
      checkboxLabel: wrapper.getAttribute('data-checkbox-label') || 'Add',
      addedLabel: wrapper.getAttribute('data-added-label') || 'Added',
      buttonStyle: wrapper.getAttribute('data-button-style') || 'checkbox',
      buttonSize: wrapper.getAttribute('data-button-size') || 'medium',
      variantLabel: wrapper.getAttribute('data-variant-label') || 'Variant',
      soldOutLabel: wrapper.getAttribute('data-sold-out-label') || 'Sold out',
      swatchRounded: wrapper.getAttribute('data-swatch-rounded') || 'round-slight',
      blockKey: 'DeskAccessories-' + (wrapper.getAttribute('data-section-id') || 'section') + '-' + (wrapper.getAttribute('data-product-id') || 'product'),
      currentAccessories: []
    };

    wrapper._deskAccessories = instance;

    ensureFormInterceptor(form);
    renderAccessories(instance, getCurrentSourceVariantId(instance));

    instance.onVariantChange = function (event) {
      renderAccessories(instance, event.detail && event.detail.variant ? event.detail.variant.id : getCurrentSourceVariantId(instance));
    };

    form.addEventListener('variant:change', instance.onVariantChange);
    document.addEventListener('variant:change', instance.onVariantChange);
  }

  function initAllDeskAccessories(root) {
    (root || document).querySelectorAll('[data-desk-accessories]').forEach(initDeskAccessories);
  }

  initAllDeskAccessories(document);

  document.addEventListener('DOMContentLoaded', function () {
    initAllDeskAccessories(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllDeskAccessories(event.target);
  });
})();
